import React, { forwardRef, useState } from 'react';
import { ExtendableImage } from '@design-system/extendable-image';
import { JsonRTE } from '@design-system/json-rte';
import { PageBlock } from '@design-system/page-block';
import { Button } from '@design-system/button';

import { MAX_VISIBLE_ITEMS } from '~/constants/rteConstants';

import { imageMapper } from '~/mappers/image';
import { getLimitedRTE } from '~/utils/getLimitedRTE';

import TMPLinkWrap from '../TMPLinkWrap';
import { JsonRTEBlockProps } from './models';

const ImageWrap =
  (images?: JsonRTEBlockProps['rteImages']) =>
    ({ uid, src, alt, ...attrs }: { uid: string; src: string; alt: string }) => {
      const image = images?.find((item) => item.uid === uid) || { url: src };
      const imageMapped = imageMapper({ image, alt, ...attrs });

      return <ExtendableImage {...imageMapped} />;
    };

const JsonRTEBlock = forwardRef<HTMLDivElement, JsonRTEBlockProps>(
  ({ pageBlockUI, componentId, rte, rteImages, cta, showLoadMore }, ref) => {

    const [expanded, setExpanded] = useState<boolean>(false);

    const { content, hasMore } = getLimitedRTE(rte, MAX_VISIBLE_ITEMS, expanded);
    return (
      <PageBlock
        {...pageBlockUI}
        id={componentId}
        className="json-rte-block"
        ref={ref}
      >
        <JsonRTE
          data={content}
          linkComponent={TMPLinkWrap}
          imageComponent={ImageWrap(rteImages)}
        />
        {showLoadMore && hasMore && !expanded ? (
          <Button {...cta} onClick={() => setExpanded(true)}  className='cds-json-rte__cta'>
            {cta?.text}
          </Button>
        ) : null}
      </PageBlock>
    )
  }
);

export default JsonRTEBlock;
